module.exports = __webpack_public_path__ + "static/media/logo_versar.4404bb52.png";